







import { Component } from 'vue-property-decorator';
import Buttons from '../../ScoreInput/Buttons.vue';
import ClassCES from './ClassCES';

@Component({ components: { Buttons } })
export default class ClassCESButton extends ClassCES {}
